module.exports = __webpack_public_path__ + "img/th_th.eaf33dff.png";